module.exports = __webpack_public_path__ + "static/media/SharpSans-Bold.481b6665.woff2";